import { useMemo } from 'react';
import { getAncestorCustomListingIdx } from '@bay-email/core';
import { useEditorContext, useFocusIdx } from '@bay-email/editor';

/**
 * Whether the focused block sits inside something that already owns a listing —
 * a Custom Listing Wrapper, or a Listing Column.
 *
 * CONTAINER panels only. A section or column inside a listing scope has nothing
 * to attach — the container above already owns the listing — so
 * `AttachedListingSection` returns null for those types, and a panel that
 * renders the Collapse.Item anyway produces a header wrapping nothing (the
 * caret looks dead because there is no body to reveal).
 *
 * Content blocks (text, image, button, table) do NOT use this. They keep their
 * own picker everywhere, including inside a scope: a block's own
 * `selectedListing` is checked before the ancestor's when the listing resolves,
 * so opting one block out of the container's listing still renders correctly.
 */
export function useInsideListingScope(): boolean {
	const { focusIdx } = useFocusIdx();
	const {
		formState: { values },
	} = useEditorContext();

	return useMemo(
		() => Boolean(getAncestorCustomListingIdx((values as any)?.content, focusIdx)),
		[values, focusIdx],
	);
}
